import React, { useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import Portal from "../Portal";
import ImperativeTooltip from "./ImperativeTooltip";

function ClickTooltip({ children, ContentRenderer, positionOnMouse, ...rest }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const mouseAnchorRef = useRef(null);
  const anchorRef = useRef(null);

  const handleClose = useCallback(() => {
    mouseAnchorRef.current.style.left = "-99px";
    mouseAnchorRef.current.style.top = "-99px";
    setShowTooltip(false);
  }, []);

  const handleClick = useCallback(
    (ev) => {
      mouseAnchorRef.current.style.left = `${ev.clientX}px`;
      mouseAnchorRef.current.style.top = `${ev.clientY}px`;
      setShowTooltip(!showTooltip);
    },
    [showTooltip]
  );

  const anchorEl = React.cloneElement(children, {
    ref: anchorRef,
    onClick: (ev) => handleClick(ev),
    onKeyDown: (e) => {
      if (e.code === "Escape") setShowTooltip(false);
      if (e.code === "ArrowDown") setShowTooltip(true);
      if (e.code === "ArrowUp") setShowTooltip(true);
      if (e.code === "ArrowLeft") setShowTooltip(true);
      if (e.code === "ArrowRight") setShowTooltip(true);
    },
  });

  return (
    <>
      <Portal shouldTrapFocus={false}>
        <div
          ref={mouseAnchorRef}
          className="tw-transform tw-pointer-events-none tw--translate-x-1/2 tw-h-4 tw-w-4 tw--translate-y-1/2 tw-fixed tw-z-10002"
        />
      </Portal>
      {anchorEl}
      {showTooltip ? (
        <ImperativeTooltip
          anchor={positionOnMouse ? mouseAnchorRef.current : anchorRef.current}
          onClose={handleClose}
          ContentRenderer={ContentRenderer}
          {...rest}
        />
      ) : null}
    </>
  );
}

ClickTooltip.propTypes = {
  ContentRenderer: PropTypes.func.isRequired,
  children: PropTypes.node,
  positionOnMouse: PropTypes.bool,
};

ClickTooltip.defaultProps = {
  children: null,
  positionOnMouse: true,
};

export default React.memo(ClickTooltip);
